import PropTypes from "prop-types";
import React from "react";
import ResourcesAdminPage from "./AdminMode/Resources";
import ResourcesLearnerPage from "./LearnerMode/Resources";

const Resources = props => {
  // eagerly create refs to scroll to
  const refs = props.sections.reduce((acc, section) => {
    acc[section.id] = React.createRef();
    return acc;
  }, {});

  const scrollToSectionByHash = () => {
    const sectionId = window.location.hash.slice(1);
    if (refs[sectionId] && refs[sectionId].current) {
      refs[sectionId].current.scrollIntoView({
        behavior: "smooth",
        block: "center"
      });
    }
  };

  if (props.isAdmin) {
    return (
      <ResourcesAdminPage
        sectionRefs={refs}
        scrollToSectionByHash={scrollToSectionByHash}
        {...props}
      />
    );
  } else {
    return (
      <ResourcesLearnerPage
        sectionRefs={refs}
        scrollToSectionByHash={scrollToSectionByHash}
        {...props}
      />
    );
  }
};

export default Resources;

Resources.propTypes = {
  isAdmin: PropTypes.bool,
  onDeleteItem: PropTypes.func,
  onDeleteSection: PropTypes.func,
  onEditItem: PropTypes.func,
  onMoveItem: PropTypes.func,
  onEditSection: PropTypes.func,
  onMoveSection: PropTypes.func,
  onItemClick: PropTypes.func,
  onOpenAddItemsModal: PropTypes.func,
  sections: PropTypes.arrayOf(
    PropTypes.shape({
      /**
       * The name of the resource section
       */
      name: PropTypes.string,
      /**
       * The resources within the resource section
       */
      items: PropTypes.arrayOf(
        PropTypes.shape({
          /**
           * The name of the resource
           */
          name: PropTypes.string,

          /**
           * The type of the resource
           */
          type: PropTypes.string
        })
      )
    })
  )
};
